import {
  InboxStackIcon,
  PowerIcon,
  UserCircleIcon,
  UserPlusIcon,
  ClockIcon,
} from "@heroicons/react/24/solid";

export const navbarProfileItems = [
  {
    label: "Mi Perfil",
    icon: UserCircleIcon,
    href: "/auth/profile",
  },
  {
    label: "Mi SLA",
    icon: ClockIcon,
    href: "/sla-metrics/users/",
    requiresUserId: true,
    fallbackHref: "/", // Fallback do dashboard when no user ID
  },
  {
    label: "Registrar usuarios",
    icon: UserPlusIcon,
    href: "/auth/register",
  },
  {
    label: "Cambiar contraseña",
    icon: InboxStackIcon,
    href: "/auth/change-password",
  },
  {
    label: "Cerrar sesión",
    icon: PowerIcon,
    href: "/auth/logout",
  },
];
